
import React, { useEffect, useState } from 'react'
import AddHeader from '../components/AddHeader/AddHeader'
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import FilterContainer from '../components/FilterContainer/FilterContainer';
import CustomTable from '../components/CustomTable/CustomTable';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import { deleteBanner, fetchBanners } from '../hooks/Banners';
import DeleteIcon from '@mui/icons-material/Delete';
import CustomModal from '../components/CustomModal/CustomModal';
import { Button, Modal } from 'react-bootstrap';

function Banners() {
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const { currentLocal } = useSelector((state) => state.currentLocal);
  const { list: banners } = useSelector((state) => state.banners);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [loading, setLoading] = useState(false)
  const [ID, setID] = useState('');
  
  useEffect(() => {
    dispatch(fetchBanners());

  }, [dispatch])
const deleteSilder=()=>{
      setLoading(true)
  
      dispatch(deleteBanner(ID))
        .unwrap()
        .then(() => {
          setLoading(false)
          alert(currentLocal.home.deletedsuccessfully)
          dispatch(fetchBanners())
setShowDeleteModal(false)  
        })
        .catch((err) => {
          setLoading(false)
  
        });
}
  const header = [
    { id: "id", numeric: false, disablePadding: true, label: currentLocal.home.ID },
    { id: "image", numeric: true, disablePadding: false, label: currentLocal.home.image },

    { id: "productName", numeric: true, disablePadding: false, label: currentLocal.home.productName },
    { id: "actions", numeric: true, disablePadding: false, label: currentLocal.home.actions },

  ];

  const myData = banners?.map((item) => {

    return {
      id: item?.id,
      image: <>
        <div className='w-25'>
          <img src={item?.image} alt='' className='w-50' />
        </div>
      </> || '---',

      productName: currentLocal.language === "العربيه" ? item?.product?.name_ar : item?.product?.name_en || '---',
      actions: (
        <div className='d-flex align-items-center'>
          {/* <div
            className='d-flex align-items-center'
            style={{ cursor: "pointer" }}
            onClick={() => navigate(`/dashboard/edit-banner/${item?.id}`)}
          >
            <BorderColorIcon
              sx={{
                color: '#6C757D',
                fontSize: '1rem',
                marginLeft: '5px',
                marginRight: '5px' // أضف مسافة بسيطة من الجهة الأخرى أيضاً
              }}
            />
            <p className='mb-0' style={{ fontSize: '1rem', color: '#6C757D' }}>
              {currentLocal.home.edit}
            </p>
          </div> */}
          <div
            className='d-flex align-items-center mx-3'
            style={{ cursor: "pointer" }}
            onClick={() => {
              setID(item?.id)
              setShowDeleteModal(true)}}
          >
            <DeleteIcon
              sx={{
                color: 'red',
                fontSize: '1.4rem',
                marginLeft: '5px',
                marginRight: '5px' // أضف مسافة بسيطة من الجهة الأخرى أيضاً
              }}
            />
            <p className='mb-0' style={{ fontSize: '1rem', color: 'red' }}>
              {currentLocal.home.delete}
            </p>
          </div>
        </div>
      )
    };
  });
  const body = <Modal.Body>
<div className='text-center'>
        <DeleteIcon
              sx={{
                color: 'rgba(220,53,69)',
                fontSize: '4rem',
                marginLeft: '5px',
                marginBottom:"12px",
                marginRight: '5px' ,
              
              }}
            />
</div>
    <p className='mb-0 text-center fw-bold'>
  {currentLocal.home.deleteThis}{" "}{currentLocal.home.banner}?
    </p>
  </Modal.Body>
  const footer = <Modal.Footer className='border-0 text-center m-auto'>
    <Button variant="danger" onClick={() => setShowDeleteModal(false)}>{currentLocal.home.close}</Button>

    <Button variant="primary" onClick={deleteSilder}>{currentLocal.home.delete}</Button>
  </Modal.Footer>
  return (
    <div className='outlit_bg px-4'>
      <AddHeader
        title={currentLocal.home.banners}
        text={currentLocal.home.addbanner}
        handleSubmit={() => navigate("/dashboard/add-banner")}
      />
      <CustomModal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        size={"md"}
        body={body}
        footer={footer}
      />
      <FilterContainer
        exportexcel={false}
        searchState={false}
      />
      {banners?.length > 0 &&
        <div className='mx-4'>
          <CustomTable
            headCells={header}
            rows={myData} />
        </div>
      }
    </div>
  )
}

export default Banners
